import styles from './PaymentVideoItem.module.scss';
//import { IVideo } from "../../types/types";
import { FC, useEffect, useState } from 'react';
import { youtubeAxios } from "../../utils/utils";
import { IYouTube } from "../../utils/youtube";
import { Button, Spin, notification } from "antd";
import { IVideo } from '../../types/types';


interface IVideoItemProps {
    video: IVideo
}

export const PaymentVideoItem: FC<IVideoItemProps> = ({ video }) => {

    const [ytData, setYtData] = useState<IYouTube>();
    const [isLoading, setIsLoading] = useState(false);

    let videoId = video.link.split("?")[1].split("=")[1];

    useEffect(() => {
        test();
    }, []);

    const test = async () => {
        setIsLoading(true);
        try {
            const { data } = await youtubeAxios.get(`/videos?part=snippet&id=${videoId}`);
            setYtData(data);
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            notification.error({ message: `Данные из ${video.link} не удалось получить!` });
        }
    }

    return <>
        <div className={styles.video_item_container}>
            <div className={styles.container}>
                {
                    !isLoading ? <>
                        <div className={styles.video_item}>
                            <img src={`${ytData?.items[0].snippet.thumbnails.default.url}`} />
                            <div>
                                <div className={styles.title}>{ytData?.items[0].snippet.title}</div>
                                <div className={styles.info_container}>
                                    <div>
                                        <div className={styles.other}><span>Канал:</span> {ytData?.items[0].snippet.channelTitle}</div>
                                        <div className={styles.other}><span>Просмотры на ютуб:</span> {ytData?.items[0].statistics.viewCount}</div>
                                        <div className={styles.other}><span>Сохраненные просмотры: </span>{video.recentViews}</div>
                                    </div>
                                    <div>
                                        <div className={styles.other}><span>Ник: </span>{}</div>
                                        <div className={styles.other}><span>Тг:</span> {}</div>
                                        <div className={styles.other}><span>ID юзера: </span>{}</div>
                                    </div>
                                    <div>
                                        <div className={styles.other}><span>Трек: </span>{}</div>
                                        <div className={styles.other}><span>ID трека:</span> {}</div>
                                    </div>
                                </div>
                            </div>

                            <Button>Начислить</Button>
                        </div>
                    </> : <Spin />
                }
            </div>
        </div>
    </>

}